// extracted by mini-css-extract-plugin
module.exports = {"btn":"BuyNowButton_btn__1MpKA"};